(function () {
  angular.module('MktzapApp.Factories')
    .factory('ControlListService', ControlListService);

    ControlListService.$inject = ['$resource'];

  function ControlListService ($resource) {
    return $resource('', {}, {
      getList: { url: frontUrl + '/control-list/getList', method: 'GET', isArray: true },
      save: { url: frontUrl + '/control-list/save', method: 'POST', isArray: false }, 
      getPerson: { url: frontUrl + '/control-list/getPerson', method: 'GET', isArray: false },
      removePersonId: { url: frontUrl + '/control-list/removePersonId', method: 'POST', isArray: false },
      removePersonAll: { url: frontUrl + '/control-list/removePersonAll', method: 'POST', isArray: false },
      uploadFile: { url: frontUrl + '/control-list/uploadFile', method: 'POST', params: {}, isArray: false },
    });
  }
})();
